module.exports = __webpack_public_path__ + "img/zj2.b1c67ca8.png";